import { AsyncFilter, useLiveSearch } from '@webapp/util/LiveSearch'
import { ViewFamily, ViewPerson } from './ResearchDataModel'
import { useViewPersonStore } from './ViewPersonStore'
import { useViewFamilyStore } from './ViewFamilyStore'

export function useLivePersonSearch(postFilter?: AsyncFilter<ViewPerson>) {
    const viewPersonStore = useViewPersonStore()

    async function searchForViewPersonsAsync(text: string, postFilter?: AsyncFilter<ViewPerson>): Promise<ViewPerson[]> {
        // NOTE: commas are not allowed in name searches, because they are used to separate names in the request
        const names = text.replace(',', ' ').split(' ').map(n => n.trim()).filter(n => n.length > 0)
        const persons = (await viewPersonStore.searchByNamesAsync(names)).map(a => a.data!)
        if (postFilter) {
            return await postFilter(persons)
        }
        return persons
    }

    return useLiveSearch<ViewPerson>(t => searchForViewPersonsAsync(t, postFilter))
}

export function useLiveFamilySearch(postFilter?: AsyncFilter<ViewFamily>) {
    const viewFamilyStore = useViewFamilyStore()

    async function searchForViewFamiliesAsync(text: string, postFilter?: AsyncFilter<ViewFamily>): Promise<ViewFamily[]> {
        // NOTE: commas are not allowed in name searches, because they are used to separate names in the request
        const names = text.replace(',', ' ').split(' ').map(n => n.trim()).filter(n => n.length > 0)
        const persons = (await viewFamilyStore.searchByNamesAsync(names)).map(a => a.data!)
        if (postFilter) {
            return await postFilter(persons)
        }
        return persons
    }

    return useLiveSearch<ViewFamily>(t => searchForViewFamiliesAsync(t, postFilter))
}
